import React from "react";
// const Home = React.lazy(() => import("../pages/HomeDashLayout1/Home"));
const Home = React.lazy(() => import("../pages/HomeDashLayout2/Home"));
const Pathway = React.lazy(() => import("../pages/Pathway/Pathway"));
const Linelist = React.lazy(() => import("../pages/Linelist/Linelist"));
const Qrcode = React.lazy(() => import("../pages/QRcode/Qrcode"));
const AdherenceCalendar = React.lazy(() => import("../pages/AdherenceCalendar/AdherenceCalendar"));
const Alerts = React.lazy(() => import("../pages/Alerts/Alerts"));

const routes = [
  {
    path: "/home",
    component: Home,
  },
  {
    path: "/dashboard",
    component: Home,
  },
  {
    path: "/linelist",
    component: Linelist,
  },
  {
    path: "/qrcode",
    component: Qrcode,
  },
  {
    path: "/alerts",
    component: Alerts,
  },
  {
    path: "/pathway",
    component: Pathway,
  },
  {
    path: "/adherencecalendar",
    component: AdherenceCalendar,
  },
  {
    default: "/",
    path: "/",
    component: Home,
  }
];

export default routes;
